// src/pages/Home.js
import React from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();
  return (
    <div className="home-wrap">
      <div className="cards">
        <button className="card" onClick={() => navigate("/staff")}>
          <span>직원 정보 페이지</span>
        </button>
        <button className="card" onClick={() => navigate("/events")}>
          <span>이벤트 정보 페이지</span>
        </button>
      </div>
    </div>
  );
}
